import React from "react";
import { homeHeroContent } from "../../content/home/homeHeroContent";
import { useNavigate } from "react-router-dom";

const HomeHero: React.FC = () => {
    const navigate = useNavigate();
    return (
        <section className="w-full bg-[#111111] text-white">
            <div className="max-w-7xl mx-auto px-6 pb-40 pt-40 md:pt-60 flex flex-col md:flex-row items-center gap-12">

                <div className="flex-1">
                    <p className="!text-[24px] mb-2 text-white !font-['Roboto_Serif']">
                        {homeHeroContent.welcomeText}
                    </p>

                    <h1 className="text-[48px] md:text-[60px] leading-tight mb-6 !font-['Roboto_Serif']">
                        {homeHeroContent.title}
                    </h1>

                    <p className="text-white !text-[20px] max-w-xl mb-8 leading-relaxed !font-light">
                        {homeHeroContent.description}
                    </p>

                    <button 
                        className="border border-[#D4A752] text-[#D4A752] px-6 py-3 rounded hover:bg-[#D4A752] hover:text-black transition"
                        onClick={() => {
                            navigate("/contact");
                        }}    
                    >
                        
                        {homeHeroContent.buttonText}
                    </button>
                </div>

                <div className="flex-1">
                    <img
                        src={homeHeroContent.image}
                        alt={homeHeroContent.imageAlt}
                        className="w-full h-[300px] md:h-[380px] object-cover"
                    />
                </div>
            </div>
        </section>
    );
};

export default HomeHero;